import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone-small",
  "use": "icon-phone-small-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone-small\"><path d=\"M746.667 106.667H277.333c-36.266 0-64 27.733-64 64v682.666c0 36.267 27.734 64 64 64h469.334c36.266 0 64-27.733 64-64V170.667c0-36.267-27.734-64-64-64z m-469.334 42.666h469.334c12.8 0 21.333 8.534 21.333 21.334V704H256V170.667c0-12.8 8.533-21.334 21.333-21.334z m469.334 725.334H277.333c-12.8 0-21.333-8.534-21.333-21.334V746.667h512v106.666c0 12.8-8.533 21.334-21.333 21.334z\" /><path d=\"M405.333 256h213.334c10.666 0 21.333-8.533 21.333-21.333 0-10.667-10.667-21.334-21.333-21.334H405.333C394.667 213.333 384 224 384 234.667S394.667 256 405.333 256z m128 533.333h-42.666c-10.667 0-21.334 10.667-21.334 21.334S480 832 490.667 832h42.666c10.667 0 21.334-10.667 21.334-21.333S544 789.333 533.333 789.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone-small.svg
// module id = bklJ
// module chunks = 65